import { useEffect, useState } from "react"

export default function CollapsingSection({title, className, children, actionButtons, isExpanded, showSeparator}) {

    const [expanded, setExpanded] = useState(true)
    useEffect(() => {
        if (isExpanded !== undefined) setExpanded(isExpanded)
    }, [isExpanded])

    return(<>
        <div className="flex center space-between gap-xd wrap v-spacer-m">
            <div className="flex center gap-xs">
                <p className={className ?? 'section-title-s'}>{title}</p>
            </div>
            <div className="flex center gap-xs">
                {actionButtons}
                <button className="with-icon icon outline" onClick={() => setExpanded(it => !it)}>
                    <span className="material-symbols-outlined scale-s vi-spacer-xxs">{expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</span>
                </button>
            </div>
        </div>    
        {expanded && children}
        {!expanded && (showSeparator || showSeparator === undefined) && <hr className="o-25"/>}
    </>)
}